export enum AnalyticsModuleType {
  courses = 'courses',
  library = 'library',
  myCourses = 'my courses',
  checklists = 'checklists',
  todo = 'todo',
  toDos = 'todos',
  settings = 'settings',
  timeMaterial = 'time material',
  companies = 'companies',
  glossary = 'glossary',
  forms = 'forms',
  templates = 'templates',
  timeOff = 'time off',
  deals = 'deals',
  organizations = 'organizations',
  contacts = 'contacts',
  media = 'media',
  projectBoard = 'project board',
  projectTemplates = 'project templates',
  orders = 'orders',
  orderPackages = 'order packages',
  orderItems = 'order items',
  orderPurchaseOrders = 'order purchase orders',
  orderSuppliers = 'order suppliers',
  orderBrands = 'order brands',
  subscriptionBoard = 'subscription board',
  subscriptionTemplate = 'subscription template',
  supportTickets = 'support tickets',
  supportTicketsCategory = 'support tickets category',
  reports = 'reports',
  dashboard = 'dashboard',
  myAccount = 'my account',
  users = 'users',
  activityLog = 'activity log',
  teams = 'teams',
  automation = 'automation',
  reviews = 'reviews',
  presentation = 'presentation',
  proposal = 'proposal',
}

export const TagToAnalyticsModuleMap: Record<string, AnalyticsModuleType> = {
  // Proposal / Deals / Sales
  Proposal: AnalyticsModuleType.proposal,
  Deals: AnalyticsModuleType.deals,
  Contacts: AnalyticsModuleType.contacts,

  // Courses / Training
  Courses: AnalyticsModuleType.courses,
  Training: AnalyticsModuleType.courses, // If you use "Training" anywhere
  Library: AnalyticsModuleType.library,
  ToDos: AnalyticsModuleType.todo,
  toDos: AnalyticsModuleType.toDos, // if you use "ToDos" anywhere

  // Projects / Boards
  Project: AnalyticsModuleType.projectBoard,
  ProjectTemplates: AnalyticsModuleType.projectTemplates,
  Templates: AnalyticsModuleType.templates,

  // Company / Organization
  Company: AnalyticsModuleType.companies,
  Organization: AnalyticsModuleType.organizations,
  Home: AnalyticsModuleType.dashboard, // Home is your Dashboard technically

  // Orders / Items / Vendors
  Orders: AnalyticsModuleType.orders,
  Packages: AnalyticsModuleType.orderPackages,
  Products: AnalyticsModuleType.orderItems,
  PurchaseOrders: AnalyticsModuleType.orderPurchaseOrders,
  Vendors: AnalyticsModuleType.orderSuppliers,
  Brands: AnalyticsModuleType.orderBrands,

  // Subscription
  Subscription: AnalyticsModuleType.subscriptionBoard,
  SubscriptionTemplate: AnalyticsModuleType.subscriptionTemplate,

  // Support
  Support: AnalyticsModuleType.supportTickets,
  SupportCategory: AnalyticsModuleType.supportTicketsCategory,

  // Reports / Analytics
  Reports: AnalyticsModuleType.reports,
  Dashboard: AnalyticsModuleType.dashboard,

  // Settings / Forms
  Settings: AnalyticsModuleType.settings,
  Forms: AnalyticsModuleType.forms,
  Integrations: AnalyticsModuleType.settings, // settings subgroup
  Permissions: AnalyticsModuleType.settings, // settings subgroup
  Webhook: AnalyticsModuleType.settings,
  Import: AnalyticsModuleType.settings,

  // Users / Accounts
  Users: AnalyticsModuleType.users,
  ActivityLog: AnalyticsModuleType.activityLog,
  MyAccount: AnalyticsModuleType.myAccount,

  // Teams
  Teams: AnalyticsModuleType.teams,

  // Media
  Media: AnalyticsModuleType.media,
  Files: AnalyticsModuleType.media, // if "Files" means uploaded files/media

  // Automation / Reviews / Presentation
  Automation: AnalyticsModuleType.automation,
  Reviews: AnalyticsModuleType.reviews,
  Presentation: AnalyticsModuleType.presentation,

  // Others (optional mapping you may have)
  TrainingInbox: AnalyticsModuleType.myCourses, // if you ever use instructor inbox or student inbox
  Students: AnalyticsModuleType.myCourses,

  // Time Material
  TimeMaterial: AnalyticsModuleType.timeMaterial,
  TimeOff: AnalyticsModuleType.timeOff,
  // Checklists
  Checklists: AnalyticsModuleType.checklists,
  // Glossary
  Glossary: AnalyticsModuleType.glossary,
};
